import ES from "./es"
import EN from "./en"

export interface IIndexable {
    [key: string]: any;
}

export const getTranslation: (key: string, isEnglish: boolean) => string =
    (key: string, isEnglish: boolean) => isEnglish ? (EN as IIndexable)[key] : (ES as IIndexable)[key] 